export const environment = {
    production: 'true',
    envName: 'famaz',
    base: 'http://www.famaz.edu.br',
    ceumaHost: 'https://www.famaz.edu.br/novoportal',
    wpBaseUrl: 'https://www.famaz.edu.br/famaz-wordpress/index.php/',
    //apiBaseUrl: 'http://localhost:8089/',
    apiBaseUrl: 'https://www.famaz.edu.br',
    apiBaseKey: '25231f2bd30c3c3d490e1e9a03729f94',
    apiBasePath: '/vestibular-api',
    authPath:'https://www.extranet.ceuma.br',
    authBasePath: '/authentication-api',
    matrPath: 'https://www.extranet.ceuma.br',
    apiNotExtranet: 'http://www.famaz.edu.br',
    recaptchaKey: '6LfI7aIUAAAAAF52dUXDLfsqjleq0kB-YHuhpbV-',
    analyticsKey: 'UA-47244799-1',
    checkoutKey: 'cd15694f775ae81cda5d336ec0948789',
    checkoutKeyPos: '93c5c81497dd2d2e6123d55dcdf366a4',
    baseHref: '/',
    // apiMatriPath: '/matricula-api'
    checkoutBasePath: '/checkout-api',
    loginContexto: 'FAMAZ',
    validacaoDocumentosBasePath:'https://www.extranet.ceuma.br',
    // FLAGS
    flagPosGraduacao: 'false',
    flagPosGraduacao2ViaBoleto: 'false',
    flagRematricula: 'true',
    //Novos paths
    egressoPath: '/universidade/egressos',
    //calendarioAcademicoPath: 'https://www.famaz.edu.br/famaz-wordpress/wp-content/uploads/2020/09/famaz20202.pdf',
    calendarioAcademicoPath: 'https://www.famaz.edu.br/famaz-wordpress/wp-content/uploads/2021/02/CALENDARIO_UNIFAMAZ_2021.pdf',
    calendarioAcademicoURLWP: 'https://www.famaz.edu.br/famaz-wordpress//wp-json/wp/v2/documentos?_embed=true&per_page=15&filter%5Bdocument_type%5D=calendario-academico',
    title: 'Centro Universitário Metropolitano da Amazônia',
    rematriculaPath:'https://www.famaz.edu.br/sitenovo/matricula/',
    centralDoContratantePath: 'http://www.famaz.edu.br/AreaDoContratante/login',
    posGraduacaoPath: 'http://www.famaz.edu.br/sitenovo/posgraduacao/index.asp',
    extensaoPath: 'http://www.famaz.edu.br/sitenovo/posgraduacao/extensao.asp',
    bibliotecaPath: 'http://www.famaz.edu.br/portal/biblioteca/',
    eadPath: 'https://ead.grupoceuma.com.br/',
    renovacaoBibliotecaPath:'http://www.famaz.edu.br/sitenovo/servicos/biblioteca/login.asp',
    validacaoDocumentosPath:'https://www.famaz.edu.br/ValidacaoDocumentos/',
    facebookPath:'https://www.facebook.com/unifamaz/',
    twitterPath:'https://twitter.com/UnifamazOficial',
    youtubePath:'https://www.youtube.com/user/faculdadefamaz/',
    instagramPath:'https://www.instagram.com/unifamaz_oficial/',
    loginPath: 'http://www.famaz.edu.br/portal/login/',
    emailVestibular: 'vestibular.medicina@famaz.edu.br',
    //Variavel de habilitação de integração de declaração de veracidade do vestibular de medicina
    docmentoVeracidadeInfoMedic: false,
    /* Dados de pagamento */
    codigoServicoVestibular:4,
    codigoServicoMatricula:5,
    codigoSistemaVestibular: 1,
    codigoSistemaMatricula: 2,
    pathDeclaracao: 'https://www.famaz.edu.br/famaz-wordpress/wp-content/uploads/2020/04/ANEXOI-Declara%C3%A7%C3%A3o-de-Veracidade-e-Autenticidade-VESTIBULAR-MEDICINA.pdf',
    pathMatriculaDigital: 'https://www.famaz.edu.br/matricula-digital/',
    codigoCategoriaBiblioteca: '632'
  };
